<script>
import Loader from "@/components/loader.vue";

export default {
  name: 'ScrollLoad',
  components: {Loader},
  props: {
    value: {
      type: Number,
      required: true
    },
    perPage: {
      type: Number,
      required: true
    },
    totalRows: {
      type: Number,
      required: true
    },
    loading: {
      type: Boolean,
      required: true
    },
    threshold: {
      type: Number,
      default: .5
    }
  },
  data() {
    return {
      observer: null
    };
  },
  mounted() {
    this.observer = new IntersectionObserver(this.scrollPage, {
      threshold: this.threshold
    });

    this.observer.observe(this.$refs.btn);
  },
  methods: {
    scrollPage() {
      if (this.loading) {
        return;
      }

      this.$emit('input', this.value + 1);
    }
  },
};
</script>

<template>
  <b-col class="text-center">
    <loader v-show="loading" :loading="true"></loader>
    <b-btn ref="btn" v-show="(perPage * value) < totalRows && !loading" class="w-100" @click="scrollPage">
      <i class="bx bxs-down-arrow label-icon"></i>
    </b-btn>
  </b-col>
</template>